// extracted by mini-css-extract-plugin
module.exports = {"container":"_2CbfV","titleAndContent":"_2K6d4","title":"_2J581","content":"_6gB2J","extraFooterSpacing":"Q9Aez"};